<template>
  <div>
    <v-autocomplete
      v-model="innerValue"
      dense
      :loading="loading"
      :items="items"
      return-object
      chips
      deletable-chips
      clearable
      item-value="id"
      tags
      :rules="required ? [(v) => !!v] : []"
      :multiple="multiple"
      :label="label"
      :item-text="
        (item) => {
          return itemText(item)
        }
      "
      @change="onChange"
    />
  </div>
</template>

<script>
export default {
  name: "PickerMixin",
  props: {
    value: {
      required: true,
    },
    multiple: {
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      required: true,
    },
  },
  mounted() {
    //if (this.$store.state.squad.data.length == 0) {
    this.loading = true
    this.fetchData()
      .then(() => {
        this.updateData(this.value)
      })
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    innerValue: {
      get() {
        return this.$props.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  data: function () {
    return {
      search: "",
      loading: false,
    }
  },
  methods: {
    itemText() {
      return "NA"
    },
    async fetchData() {
      this.loading = true
      await this.FETCH({ limit: -1 })
      this.loading = false
    },
    onChange(e) {
      this.$emit("input", e)
    },
    updateData(val) {
      if (val && !this.loading) {
        if (this.multiple) {
          this.innerValue = this.value.map((value) =>
            this.items.find((item) => item.id === value.id)
          )
        } else {
          this.innerValue = this.items.find((item) => item.id === this.value.id)
        }
      }
    },
  },

}
</script>
